import { offeringGameplayProfile } from '@/data/offeringKnowledge'

const ITEM_BUILD_PROFILES = {
  1: {
    id: 'key',
    perkTags: ['key', 'chest', 'loot', 'hatch', 'obsession', 'teamwork'],
    targetTags: ['Auras', 'Chests', 'Hatch', 'Obsession', 'RummageAbility']
  },
  3: {
    id: 'flashlight',
    perkTags: ['item', 'support', 'chase', 'stun', 'escape'],
    targetTags: ['KillerBlind', 'KillerStun', 'Pallets', 'Chase', 'Haste']
  },
  5: {
    id: 'map',
    perkTags: ['information', 'aura', 'generator', 'totem', 'objective', 'solo_queue'],
    targetTags: ['Auras', 'Tracking', 'Generators', 'Totems', 'Hatch']
  },
  6: {
    id: 'medkit',
    perkTags: ['item', 'support', 'heal', 'injured', 'rescue'],
    targetTags: ['Healing', 'HealingProficiency', 'SelfHeal', 'InjuredState', 'Altruism']
  },
  7: {
    id: 'toolbox',
    perkTags: ['item', 'generator', 'repair', 'objective', 'sabotage'],
    targetTags: ['Generators', 'Repairing', 'RepairingProficiency', 'Sabotage', 'SabotageProficiency']
  },
  8: {
    id: 'fogVial',
    perkTags: ['stealth', 'occlusion', 'scratchmark'],
    targetTags: ['Stealth', 'ScratchMarks', 'Occlusion']
  }
}

const ITEM_FIT_RULES = {
  1: { signals: ['loot', 'obsession'], keywords: ['key', 'chest', 'hatch', 'rummage', 'obsession', 'teamwork'] },
  3: { signals: ['chase', 'hook'], keywords: ['flashlight', 'killerblind', 'blind', 'stun', 'pickup', 'save'] },
  5: { signals: ['information', 'totem', 'generator'], keywords: ['totem', 'hex', 'boon', 'aura', 'tracking', 'pallet', 'window', 'generator'] },
  6: { signals: ['healing', 'hook'], keywords: ['heal', 'selfheal', 'injured', 'altruism', 'rescue'] },
  7: { signals: ['generator', 'sabotage', 'hook'], keywords: ['repair', 'generator', 'sabotage', 'wiggle', 'carrying'] },
  8: { signals: ['stealth'], keywords: ['scratchmark', 'occlusion', 'disappear', 'reposition', 'rotation', 'prerun'] }
}

const ITEM_QUALITY = {
  broken_key: 1,
  dull_key: 9,
  skeleton_key: 15,
  flashlight: 4,
  sport_flashlight: 9,
  utility_flashlight: 15,
  anniversary_flashlight: 6,
  banquet_flashlight: 6,
  masquerade_flashlight: 6,
  will_o_wisp: 6,
  apprentice_s_fog_vial: 2,
  artisan_s_fog_vial: 5,
  vigo_s_fog_vial: 8,
  cryptic_map: 2,
  scribbled_map: 7,
  annotated_map: 11,
  bloodsense_map: 13,
  camping_aid_kit: 3,
  first_aid_kit: 7,
  emergency_med_kit: 12,
  ranger_med_kit: 15,
  anniversary_med_kit: 7,
  banquet_med_kit: 7,
  masquerade_med_kit: 7,
  all_hallows_eve_lunchbox: 7,
  worn_out_tools: 2,
  toolbox: 6,
  mechanic_s_toolbox: 10,
  commodious_toolbox: 13,
  engineer_s_toolbox: 15,
  alex_s_toolbox: 13,
  anniversary_toolbox: 7,
  banquet_toolbox: 7,
  festive_toolbox: 7,
  masquerade_toolbox: 7
}

const ITEM_TRAITS = {
  alex_s_toolbox: ['sabotage'],
  engineer_s_toolbox: ['generator', 'speed'],
  commodious_toolbox: ['generator', 'capacity'],
  mechanic_s_toolbox: ['generator', 'speed'],
  skeleton_key: ['endgame', 'information'],
  dull_key: ['endgame', 'information'],
  utility_flashlight: ['chase', 'strength'],
  sport_flashlight: ['chase', 'speed'],
  ranger_med_kit: ['healing', 'capacity'],
  emergency_med_kit: ['healing', 'speed'],
  bloodsense_map: ['information', 'capacity'],
  annotated_map: ['information', 'duration'],
  vigo_s_fog_vial: ['stealth', 'duration']
}

const EVENT_RARITIES = [8, 11]
const EVENT_TAGS = [
  'event',
  'anniversaryevent',
  'halloweenevent',
  'springevent',
  'summerevent',
  'winterevent',
  'lunarevent'
]

const SURVIVOR_ADDON_PAIR_PLANS = {
  1: [
    { id: 'killer_tracking', pairs: [['blood_amber', 'friendship_charm'], ['blood_amber', 'braided_bauble']], signals: ['information', 'chase'], keywords: ['aura', 'killer'] },
    { id: 'fast_key_utility', pairs: [['shrill_whistle', 'friendship_charm'], ['shrill_whistle', 'braided_bauble']], signals: ['loot', 'endgame', 'information'], keywords: ['hatch', 'chest'] },
    { id: 'obsession_information', pairs: [['unique_wedding_ring', 'friendship_charm'], ['unique_wedding_ring', 'braided_bauble']], signals: ['information', 'obsession'], keywords: ['obsession', 'aura'] }
  ],
  3: [
    { id: 'flash_save', pairs: [['wide_lens', 'rubber_grip'], ['wide_lens', 'long_life_battery'], ['wide_lens', 'low_amp_filament']], signals: ['hook', 'information'], keywords: ['save', 'rescue', 'pickup', 'flashlight'], itemIds: ['sport_flashlight'] },
    { id: 'chase_blind', pairs: [['high_end_sapphire_lens', 'long_life_battery'], ['high_end_sapphire_lens', 'heavy_duty_battery'], ['high_end_sapphire_lens', 'intense_halogen']], signals: ['chase'], keywords: ['blind', 'stun', 'pallet'], itemIds: ['utility_flashlight'] },
    { id: 'battery_endurance', pairs: [['long_life_battery', 'low_amp_filament'], ['heavy_duty_battery', 'low_amp_filament'], ['long_life_battery', 'heavy_duty_battery']], signals: ['item'], keywords: ['recharge', 'efficiency', 'charge'] },
    { id: 'maximum_blind', pairs: [['odd_bulb', 'intense_halogen'], ['odd_bulb', 'high_end_sapphire_lens'], ['intense_halogen', 'high_end_sapphire_lens']], signals: ['chase'], keywords: ['blind', 'hindered'] }
  ],
  5: [
    { id: 'totem_hunter', pairs: [['sharpened_flint', 'battered_tape'], ['sharpened_flint', 'glowing_ink'], ['sharpened_flint', 'gnarled_compass']], signals: ['totem', 'information'], keywords: ['totem', 'hex', 'boon'] },
    { id: 'killer_scouting', pairs: [['crimson_stamp', 'battered_tape'], ['crimson_stamp', 'gnarled_compass'], ['crimson_stamp', 'glowing_ink']], signals: ['information', 'chase'], keywords: ['killer', 'aura'] },
    { id: 'long_range_mapping', pairs: [['battered_tape', 'glowing_ink'], ['battered_tape', 'gnarled_compass'], ['glowing_ink', 'gnarled_compass']], signals: ['information', 'generator'], keywords: ['aura', 'tracking', 'objective'] }
  ],
  6: [
    { id: 'double_self_heal', pairs: [['gel_dressings', 'gauze_roll'], ['gel_dressings', 'bandages']], signals: ['healing'], keywords: ['selfheal', 'selfhealing', 'efficiency'] },
    { id: 'personal_heal_efficiency', pairs: [['gel_dressings', 'styptic_agent'], ['self_adherent_wrap', 'styptic_agent']], signals: ['healing'], keywords: ['selfheal', 'selfhealing', 'injured'] },
    { id: 'altruistic_heal_speed', pairs: [['abdominal_dressing', 'medical_scissors'], ['abdominal_dressing', 'butterfly_tape'], ['medical_scissors', 'self_adherent_wrap']], signals: ['healing', 'hook'], keywords: ['altruism', 'rescue', 'healother'] },
    { id: 'great_skill_checks', pairs: [['needle_thread', 'surgical_suture'], ['surgical_suture', 'sponge'], ['needle_thread', 'rubber_gloves']], signals: ['healing', 'generator'], keywords: ['skillcheck', 'bonusprogression'] },
    { id: 'exhaustion_reset', pairs: [['anti_exhaustion_syringe', 'self_adherent_wrap'], ['anti_exhaustion_syringe', 'abdominal_dressing']], signals: ['chase', 'healing'], keywords: ['exhausted', 'exhaustion'] }
  ],
  7: [
    { id: 'generator_capacity', pairs: [['wire_spool', 'scraps'], ['wire_spool', 'socket_swivels'], ['wire_spool', 'clean_rag']], signals: ['generator'], keywords: ['repair', 'recharge', 'efficiency'], itemIds: ['commodious_toolbox'] },
    { id: 'generator_burst', pairs: [['socket_swivels', 'clean_rag'], ['brand_new_part', 'socket_swivels'], ['brand_new_part', 'wire_spool']], signals: ['generator'], keywords: ['repair', 'progression', 'skillcheck'], itemIds: ['engineer_s_toolbox', 'mechanic_s_toolbox'] },
    { id: 'sabotage_speed', pairs: [['hacksaw', 'cutting_wire'], ['hacksaw', 'wire_spool'], ['cutting_wire', 'wire_spool']], signals: ['sabotage', 'hook'], keywords: ['sabotage', 'wiggle', 'carrying'], itemIds: ['alex_s_toolbox'] },
    { id: 'sabotage_control', pairs: [['grip_wrench', 'wire_spool'], ['grip_wrench', 'hacksaw'], ['grip_wrench', 'cutting_wire']], signals: ['sabotage', 'hook'], keywords: ['sabotage', 'hook', 'save'], itemIds: ['alex_s_toolbox'] }
  ],
  8: [
    { id: 'maximum_concealment', pairs: [['potent_extract', 'mushroom_formula'], ['potent_extract', 'oily_sap'], ['potent_extract', 'reactive_compound']], signals: ['opacity'], keywords: ['opacity', 'dense', 'insidecloud'] },
    { id: 'fast_deploy_cloud', pairs: [['mushroom_formula', 'reactive_compound'], ['oily_sap', 'reactive_compound']], signals: ['stealth'], keywords: ['prerun', 'occlusion', 'rotation', 'scratchmark'] },
    { id: 'large_lasting_cloud', pairs: [['mushroom_formula', 'oily_sap'], ['mushroom_formula', 'reactive_compound']], signals: ['stealth', 'information'], keywords: ['duration', 'radius', 'occlusion'] },
    { id: 'repeatable_cloud', pairs: [['volcanic_stone', 'reactive_compound'], ['volcanic_stone', 'oily_sap'], ['volcanic_stone', 'mushroom_formula']], signals: ['item', 'stealth'], keywords: ['recharge', 'resource', 'repeat'] }
  ]
}

const SIGNAL_ALIASES = [
  { signal: 'information', keywords: ['aura', 'tracking', 'reveal', 'notification', 'scream', 'killerinstinct'] },
  { signal: 'generator', keywords: ['generator', 'repair', 'objective', 'skillcheck'] },
  { signal: 'healing', keywords: ['heal', 'injured', 'selfheal', 'mangled', 'haemorrhage', 'altruism'] },
  { signal: 'chase', keywords: ['chase', 'pallet', 'window', 'vault', 'lunge', 'haste', 'exposed', 'blind', 'stun'] },
  { signal: 'stealth', keywords: ['stealth', 'scratchmark', 'occlusion', 'undetectable', 'oblivious', 'terror'] },
  { signal: 'item', keywords: ['item', 'charge', 'efficiency', 'resource'] },
  { signal: 'loot', keywords: ['chest', 'loot', 'rummage', 'raritybonus'] },
  { signal: 'hook', keywords: ['hook', 'rescue', 'unhook', 'sacrifice', 'carrying', 'dying'] },
  { signal: 'totem', keywords: ['totem', 'hex', 'boon'] },
  { signal: 'sabotage', keywords: ['sabotage'] },
  { signal: 'endgame', keywords: ['hatch', 'exitgate', 'endgame', 'survival'] },
  { signal: 'obsession', keywords: ['obsession'] },
  { signal: 'power', keywords: ['power', 'deviousness', 'extendedability'] },
  { signal: 'bloodpoints', keywords: ['bloodpoint', 'allcategories', 'personal'] }
]

const ADDON_FAMILY_RULES = [
  { id: 'capacity', keywords: ['charge', 'capacity', 'token', 'ammo'] },
  { id: 'speed', keywords: ['actionspeed', 'proficiency', 'rechargespeed', 'rechargetime', 'recovery', 'expansion'] },
  { id: 'duration', keywords: ['duration', 'timer'] },
  { id: 'range', keywords: ['range', 'radius', 'distance'] },
  { id: 'efficiency', keywords: ['efficiency', 'consumption', 'cost', 'depletion'] },
  { id: 'skillcheck', keywords: ['skillcheck', 'accuracy'] },
  { id: 'tracking', keywords: ['aura', 'tracking', 'killerinstinct', 'reveal', 'generator'] },
  { id: 'strength', keywords: ['strength', 'opacity', 'blind', 'stun', 'bonus'] },
  { id: 'stealth', keywords: ['stealth', 'scratchmark', 'occlusion', 'terrorradius', 'undetectable'] },
  { id: 'status', keywords: ['exhaustion', 'mangled', 'haemorrhage', 'hindered', 'exposed', 'deepwound'] },
  { id: 'objective', keywords: ['repair', 'sabotage', 'generator', 'hook'] },
  { id: 'power', keywords: ['power', 'ability', 'specialattack'] }
]

const FAMILY_COMPLEMENTS = {
  capacity: { speed: 14, efficiency: 15, duration: 8, strength: 6 },
  duration: { range: 11, strength: 9, stealth: 9, tracking: 7 },
  tracking: { range: 11, duration: 7, speed: 6 },
  objective: { speed: 10, capacity: 8, skillcheck: 7 },
  skillcheck: { speed: 7, capacity: 5 },
  power: { duration: 8, range: 8, capacity: 8, speed: 8 },
  stealth: { duration: 9, range: 6 },
  status: { duration: 7, speed: 4 },
  strength: { range: 8, duration: 9, capacity: 6 }
}

function normalizeTag (tag) {
  return String(tag || '').toLowerCase().replace(/[^a-z0-9]+/g, '')
}

function unique (values) {
  return Array.from(new Set((values || []).filter(Boolean)))
}

function factor (id, value, detail) {
  return { id, value: Math.round(value), detail: detail || '' }
}

export function canonicalSignals (tags) {
  const normalized = (tags || []).map(normalizeTag)
  return unique(SIGNAL_ALIASES.reduce((signals, group) => {
    if (group.keywords.some(keyword => normalized.some(tag => tag.indexOf(keyword) !== -1))) signals.push(group.signal)
    return signals
  }, []))
}

function sharedSignals (first, second) {
  const target = new Set(canonicalSignals(second))
  return canonicalSignals(first).filter(signal => target.has(signal))
}

function correlationTier (score) {
  if (score >= 86) return 'perfect'
  if (score >= 72) return 'strong'
  if (score >= 56) return 'supportive'
  if (score >= 38) return 'neutral'
  return 'weak'
}

function correlationResult (score, signals, reasons, breakdown, extras) {
  const normalizedScore = Math.max(1, Math.min(99, Math.round(score)))
  const orderedBreakdown = (breakdown || [])
    .filter(entry => entry && entry.value)
    .sort((first, second) => Math.abs(second.value) - Math.abs(first.value))
  return Object.assign({
    score: normalizedScore,
    rawScore: Math.round(score),
    tier: correlationTier(normalizedScore),
    signals: unique(signals),
    reasons: unique(reasons),
    breakdown: orderedBreakdown
  }, extras || {})
}

export function effectiveRarity (rarity) {
  const value = Number(rarity) || 1
  if (value === 8 || value === 11) return 2
  return Math.max(1, Math.min(5, value))
}

function entryAvailable (entry) {
  return !(entry && entry.mechanics && entry.mechanics.notAvailable)
}

export function isEventPoolEntry (entry) {
  if (!entry) return false
  const tags = (entry.tags || []).map(normalizeTag)
  return EVENT_RARITIES.indexOf(Number(entry.rarity)) !== -1 || EVENT_TAGS.some(tag => tags.indexOf(tag) !== -1)
}

export function isGameplayOffering (offering) {
  if (!entryAvailable(offering) || !offering) return false
  const tags = (offering.tags || []).map(normalizeTag)
  const hasExact = values => values.some(value => tags.indexOf(value) !== -1)
  if (offering.mechanics && offering.mechanics.mobile) return false
  if (['white_ward', 'black_ward', 'shroud_of_separation', 'sacrificial_ward'].indexOf(offering.id) !== -1) return false
  if (hasExact(['bloodpoints', 'xp', 'event', 'mapselection', 'realmselection'])) return false
  if (hasExact(['allsurvivorsluck'])) return false
  if (hasExact(['chance', 'personalluck'])) return hasExact(['personalluck'])
  return hasExact([
    'mapmodifier',
    'mori',
    'shroud'
  ])
}

function addonPairMatches (firstId, secondId, pair) {
  return (pair[0] === firstId && pair[1] === secondId) || (pair[0] === secondId && pair[1] === firstId)
}

export function getAddonPairPlan (first, second, context) {
  if (!first || !second || !context || context.side !== 'survivor') return null
  const category = context.item ? context.item.category : (first.itemsCategory || second.itemsCategory)
  const plans = SURVIVOR_ADDON_PAIR_PLANS[category] || []
  const matches = plans.filter(plan => plan.pairs.some(pair => addonPairMatches(first.id, second.id, pair))).map(plan => {
    const perkEvidence = (context.perks || []).map(perk => {
      const tags = perk.tags || []
      const normalizedTags = tags.map(normalizeTag)
      const signals = canonicalSignals(tags)
      const signalMatches = (plan.signals || []).filter(signal => signals.indexOf(signal) !== -1)
      const keywordMatches = (plan.keywords || []).filter(keyword => normalizedTags.some(tag => tag.indexOf(keyword) !== -1))
      return {
        score: signalMatches.length * 3 + keywordMatches.length * 2,
        signalMatches,
        keywordMatches
      }
    })
    const coverage = perkEvidence.filter(evidence => evidence.score > 0).length
    const evidenceScore = perkEvidence.reduce((sum, evidence) => sum + evidence.score, 0)
    const itemBound = Boolean(plan.itemIds && plan.itemIds.length)
    const itemMatch = !itemBound || (context.item && plan.itemIds.indexOf(context.item.id) !== -1)
    const itemAdjustment = itemBound ? (itemMatch ? 8 : -6) : 0
    const primaryPlanMatches = (plan.signals || []).filter(signal => context.plan && (context.plan.primarySignals || []).indexOf(signal) !== -1)
    const secondaryPlanMatches = (plan.signals || []).filter(signal => context.plan && (context.plan.secondarySignals || []).indexOf(signal) !== -1)
    const buildPlanFit = primaryPlanMatches.length * 4 + secondaryPlanMatches.length * 2
    const planCoverage = !context.plan ? 0 : primaryPlanMatches.length ? context.plan.coverage || 0 : secondaryPlanMatches.length ? Math.min(2, context.plan.coverage || 0) : 0
    const effectiveCoverage = Math.max(coverage, planCoverage)
    const score = 10 + Math.min(24, evidenceScore) + effectiveCoverage * 3 + itemAdjustment + buildPlanFit
    return {
      id: plan.id,
      score,
      coverage: effectiveCoverage,
      coverageTotal: (context.perks || []).length,
      signalMatches: unique(perkEvidence.reduce((all, evidence) => all.concat(evidence.signalMatches), [])),
      keywordMatches: unique(perkEvidence.reduce((all, evidence) => all.concat(evidence.keywordMatches), [])),
      planSignalMatches: unique(primaryPlanMatches.concat(secondaryPlanMatches)),
      itemMatch
    }
  })
  return matches.sort((firstMatch, secondMatch) => secondMatch.score - firstMatch.score)[0] || null
}

export function getItemBuildProfile (item) {
  const fallback = {
    id: 'adaptive',
    perkTags: ['item', 'support', 'information', 'escape'],
    targetTags: ['Items', 'Auras', 'ActionSpeed']
  }
  const profile = item && ITEM_BUILD_PROFILES[item.category] ? ITEM_BUILD_PROFILES[item.category] : fallback
  return Object.assign({}, profile, {
    targetTags: unique(profile.targetTags.concat((item && item.tags) || []))
  })
}

function itemQuality (item) {
  if (!item) return 0
  if (ITEM_QUALITY[item.id] !== undefined) return ITEM_QUALITY[item.id]
  return effectiveRarity(item.rarity) * 3
}

function signalCountsForPerks (perks) {
  return (perks || []).reduce((counts, perk) => {
    canonicalSignals((perk && perk.tags) || []).forEach(signal => {
      counts[signal] = (counts[signal] || 0) + 1
    })
    return counts
  }, {})
}

function itemTraitScore (item, signalCounts) {
  const traits = ITEM_TRAITS[item.id] || []
  return traits.reduce((score, trait) => score + (signalCounts[trait] ? 3 : 0), 0)
}

function itemPlanBonus (item, signalCounts, normalizedBuildTags) {
  if (!item) return 0
  const signalCount = signal => signalCounts[signal] || 0
  const keywordCount = keyword => normalizedBuildTags.filter(tag => tag.indexOf(keyword) !== -1).length
  if (item.category === 7 && signalCount('sabotage') > signalCount('generator')) {
    if (item.id === 'alex_s_toolbox') return 18
    if (item.id === 'commodious_toolbox') return 6
    return 0
  }
  if (item.category === 7 && signalCount('generator')) {
    if (item.id === 'commodious_toolbox') return 16
    if (item.id === 'engineer_s_toolbox') return 14
    if (item.id === 'mechanic_s_toolbox') return 10
    if (item.id === 'toolbox') return 6
  }
  if (item.category === 3) {
    const flashSaveEvidence = signalCount('hook') + keywordCount('pickup') + keywordCount('save') + keywordCount('flashlight')
    const chaseEvidence = signalCount('chase') + keywordCount('pallet') + keywordCount('stun')
    if (flashSaveEvidence >= chaseEvidence) {
      if (item.id === 'utility_flashlight') return 10
      if (item.id === 'sport_flashlight') return 5
    } else {
      if (item.id === 'sport_flashlight') return 12
      if (item.id === 'utility_flashlight') return 4
    }
  }
  return 0
}

const PLAN_ITEM_VARIANT_BONUS = {
  generator_pressure: {
    engineer_s_toolbox: 20,
    commodious_toolbox: 18,
    mechanic_s_toolbox: 10,
    toolbox: 5,
    alex_s_toolbox: -22
  },
  sabotage_save: {
    alex_s_toolbox: 42,
    engineer_s_toolbox: -12,
    mechanic_s_toolbox: -8
  }
}

const PLAN_ITEM_CATEGORY_BONUS = {
  chase_escape: { 3: 18, 5: 8, 8: 2 },
  healing_support: { 6: 28 },
  generator_pressure: { 7: 60 },
  stealth_evasion: { 5: 12, 3: 6, 8: 4 },
  aura_information: { 5: 26 },
  rescue_teamplay: { 3: 16, 6: 14, 7: 8 },
  item_economy: { 7: 12, 6: 10, 5: 8, 3: 6 },
  totem_control: { 5: 30 },
  endgame_survival: { 6: 10, 3: 6, 5: 5 },
  sabotage_save: { 7: 58, 3: 8 },
  slug_recovery: { 6: 10, 5: 8 },
  protection_survival: { 6: 16, 3: 14, 7: 8 },
  linked_teamwork: { 6: 8, 7: 8, 5: 5 }
}

function itemPlanCategoryBonus (item, plan) {
  if (!item || !plan || !plan.primary) return 0
  const preferences = PLAN_ITEM_CATEGORY_BONUS[plan.primary] || {}
  const variants = PLAN_ITEM_VARIANT_BONUS[plan.primary] || {}
  return (preferences[item.category] || 0) + (variants[item.id] || 0)
}

function itemPerkFit (item, perk) {
  const rule = ITEM_FIT_RULES[item && item.category]
  if (!rule || !perk) return { score: 0, signals: [], keywords: [] }
  const tags = perk.tags || []
  const normalizedTags = tags.map(normalizeTag)
  const perkSignals = canonicalSignals(tags)
  const signalMatches = rule.signals.filter(signal => perkSignals.indexOf(signal) !== -1)
  const keywordMatches = rule.keywords.filter(keyword => normalizedTags.some(tag => tag.indexOf(keyword) !== -1))
  const score = Math.min(22, signalMatches.length * 8 + Math.min(8, keywordMatches.length * 4))
  return { score, signals: signalMatches, keywords: keywordMatches }
}

export function scoreItemCorrelation (item, perks, plan) {
  if (!entryAvailable(item)) return correlationResult(1, [], ['Unavailable item'], [factor('unavailable', -99)])
  const perkList = (perks || []).filter(Boolean)
  const perkFits = perkList.map(perk => itemPerkFit(item, perk))
  const coverage = perkFits.filter(fit => fit.score > 0).length
  const fitValue = perkFits.reduce((sum, fit) => sum + fit.score, 0)
  const coverageValue = coverage * 5
  const signalCounts = signalCountsForPerks(perkList)
  const normalizedBuildTags = perkList.reduce((tags, perk) => tags.concat(perk.tags || []), []).map(normalizeTag)
  const selfHealingCount = perkList.filter(perk => (perk.tags || []).map(normalizeTag).some(tag => tag.indexOf('selfheal') !== -1)).length
  const teamHealingCount = perkList.filter(perk => (perk.tags || []).map(normalizeTag).some(tag => ['altruism', 'healother', 'rescue'].some(keyword => tag.indexOf(keyword) !== -1))).length
  const isSelfHealingPlan = item.category === 6 && selfHealingCount > 0 && teamHealingCount === 0
  const quality = isSelfHealingPlan ? 4 : Math.max(1, Math.round(itemQuality(item) * 0.4))
  const traitScore = isSelfHealingPlan ? 0 : itemTraitScore(item, signalCounts)
  const specializationBonus = itemPlanBonus(item, signalCounts, normalizedBuildTags)
  const itemRule = ITEM_FIT_RULES[item && item.category]
  const primaryPlanSignals = (plan && plan.primarySignals) || []
  const secondaryPlanSignals = (plan && plan.secondarySignals) || []
  const primaryPlanMatches = itemRule ? itemRule.signals.filter(signal => primaryPlanSignals.indexOf(signal) !== -1) : []
  const secondaryPlanMatches = itemRule ? itemRule.signals.filter(signal => secondaryPlanSignals.indexOf(signal) !== -1) : []
  const planBonus = primaryPlanMatches.length * 7 + secondaryPlanMatches.length * 3
  const planCategoryBonus = itemPlanCategoryBonus(item, plan)
  const noMitherConflict = item.category === 6 && perkList.some(perk => perk.id === 'no_mither')
  const conflictPenalty = noMitherConflict ? 80 : 0
  const fogEvidence = item.category !== 8 || normalizedBuildTags.some(tag => [
    'scratchmark', 'occlusion', 'disappear', 'reposition', 'rotation', 'prerun'
  ].some(keyword => tag.indexOf(keyword) !== -1))
  const nichePenalty = fogEvidence ? 0 : 24
  const requiresItem = perkList.some(perk => perk.constraints && perk.constraints.requiresItem)
  const itemPerk = normalizedBuildTags.some(tag => tag === 'item' || tag === 'items')
  const score = 18 + fitValue + coverageValue + quality + traitScore + specializationBonus + planBonus + planCategoryBonus + (requiresItem ? 6 : 0) + (itemPerk ? 4 : 0) - conflictPenalty - nichePenalty
  const matchedSignals = unique(perkFits.reduce((signals, fit) => signals.concat(fit.signals), []))
  const breakdown = [
    factor('wholeBuildFit', fitValue),
    factor('buildCoverage', coverageValue, `${coverage}/${perkList.length}`),
    factor('itemQuality', quality),
    factor('specialization', traitScore + specializationBonus, (ITEM_TRAITS[item.id] || []).join(', ')),
    factor('buildPlanFit', planBonus + planCategoryBonus, primaryPlanMatches.concat(secondaryPlanMatches).join(', ')),
    factor('incompatible', -conflictPenalty, noMitherConflict ? 'no_mither' : ''),
    factor('nicheUseRequired', -nichePenalty, nichePenalty ? 'fog_prerun_evidence_missing' : ''),
    requiresItem ? factor('requiredItem', 6) : null,
    itemPerk ? factor('itemPerk', 4) : null
  ]
  const reasons = [`Build coverage ${coverage}/${perkList.length}`, `Whole-build fit ${fitValue}`, `Item quality ${quality}`]
  return correlationResult(score, matchedSignals, reasons, breakdown, {
    quality,
    coverage,
    coverageTotal: perkList.length,
    perkFits: perkFits.map(fit => fit.score),
    planMatch: primaryPlanMatches.concat(secondaryPlanMatches),
    planCategoryBonus,
    conflictPenalty,
    nichePenalty
  })
}
export function scoreItemForCentral (item, centralPerk) {
  return scoreItemCorrelation(item, centralPerk ? [centralPerk] : []).score
}

export function scorePerkForItem (perk, item) {
  const itemProfile = getItemBuildProfile(item)
  const matches = sharedSignals((perk && perk.tags) || [], itemProfile.perkTags.concat(itemProfile.targetTags))
  let score = (perk && (perk.strengthScore || perk.soloQueueScore)) || 50
  score += matches.length * 18
  if (perk && perk.constraints && perk.constraints.requiresItem) score += 14
  if (perk && perk.tags && perk.tags.indexOf('item') !== -1) score += 10
  return Math.max(1, score)
}

export function createLoadoutContext (options) {
  const side = options.side === 'killer' ? 'killer' : 'survivor'
  const profileTags = side === 'killer' ? (options.profile && options.profile.tags) || [] : []
  const itemProfile = side === 'survivor' ? getItemBuildProfile(options.item) : null
  const plan = options.plan || null
  const planTags = side === 'survivor' && plan
    ? (plan.primarySignals || [])
      .concat(plan.supportingSignals || [])
      .concat(plan.secondarySignals || [])
      .concat(plan.secondarySupportingSignals || [])
    : []
  const perks = options.perks || []
  const perkTags = perks.reduce((tags, perk) => tags.concat(perk.tags || [], perk.roles || [], perk.primaryRole || []), [])
  const targetTags = unique(
    profileTags
      .concat(planTags)
      .concat(itemProfile ? itemProfile.targetTags : [])
      .concat(itemProfile ? itemProfile.perkTags : [])
      .concat(perkTags)
  )
  const centralPerk = perks[0] || null
  const centralTags = centralPerk ? centralPerk.tags || [] : []
  const buildTags = unique(profileTags.concat(planTags, perkTags))
  const primaryTags = unique(
    buildTags
      .concat((options.item && options.item.tags) || [])
  )
  const perkSignalSets = perks.map(perk => canonicalSignals(perk.tags || []))
  const buildSignalCounts = signalCountsForPerks(perks)
  return {
    side,
    item: options.item || null,
    plan,
    addons: (options.addons || []).filter(Boolean),
    perks,
    itemProfile,
    centralPerk,
    centralTags,
    primaryTags,
    targetTags,
    signals: canonicalSignals(targetTags),
    buildTags,
    buildSignals: canonicalSignals(buildTags),
    perkSignalSets,
    buildSignalCounts
  }
}

export function addonFamilies (addon) {
  const source = (addon && addon.tags ? addon.tags : []).concat(Object.keys((addon && addon.mechanics) || {}))
  const normalized = source.map(normalizeTag)
  return unique(ADDON_FAMILY_RULES.filter(rule => {
    return rule.keywords.some(keyword => normalized.some(value => value.indexOf(keyword) !== -1))
  }).map(rule => rule.id))
}

function familyComplementScore (firstFamilies, secondFamilies) {
  let score = 0
  const matches = []
  firstFamilies.forEach(first => {
    secondFamilies.forEach(second => {
      const value = (FAMILY_COMPLEMENTS[first] && FAMILY_COMPLEMENTS[first][second]) ||
        (FAMILY_COMPLEMENTS[second] && FAMILY_COMPLEMENTS[second][first]) || 0
      if (value) {
        score += value
        matches.push(`${first}:${second}`)
      }
    })
  })
  return { score: Math.min(20, score), matches: unique(matches) }
}

function familyRelevance (families, context) {
  const signals = context.buildSignals || context.signals || []
  let score = 0
  if (families.indexOf('capacity') !== -1) score += 7
  if (families.indexOf('speed') !== -1 && signals.some(signal => ['healing', 'generator', 'chase', 'power'].indexOf(signal) !== -1)) score += 8
  if (families.indexOf('tracking') !== -1 && signals.indexOf('information') !== -1) score += 8
  if (families.indexOf('objective') !== -1 && signals.some(signal => ['generator', 'sabotage', 'hook'].indexOf(signal) !== -1)) score += 9
  if (families.indexOf('stealth') !== -1 && signals.indexOf('stealth') !== -1) score += 8
  if (families.indexOf('status') !== -1 && signals.some(signal => ['chase', 'healing', 'power'].indexOf(signal) !== -1)) score += 5
  if (families.some(family => ['duration', 'range', 'strength', 'power'].indexOf(family) !== -1) && signals.some(signal => ['information', 'stealth', 'chase', 'power'].indexOf(signal) !== -1)) score += 6
  return score
}

function addonBuildEvidence (addon, context) {
  const tags = (addon && addon.tags) || []
  const perkFits = (context.perks || []).map(perk => {
    const signals = sharedSignals(tags, (perk && perk.tags) || [])
    return {
      score: Math.min(12, signals.length * 8),
      signals
    }
  })
  return {
    coverage: perkFits.filter(fit => fit.score > 0).length,
    coverageTotal: perkFits.length,
    score: perkFits.reduce((sum, fit) => sum + fit.score, 0),
    signals: unique(perkFits.reduce((all, fit) => all.concat(fit.signals), [])),
    perkFits: perkFits.map(fit => fit.score)
  }
}

export function scoreAddonCorrelation (addon, context, selectedAddons) {
  if (!entryAvailable(addon)) return correlationResult(1, [], ['Unavailable add-on'], [factor('unavailable', -99)])
  const tags = (addon && addon.tags) || []
  const buildEvidence = addonBuildEvidence(addon, context)
  const itemTags = ((context.item && context.item.tags) || [])
    .concat(context.itemProfile ? context.itemProfile.targetTags : [])
    .concat(context.itemProfile ? context.itemProfile.perkTags : [])
  const itemSignals = sharedSignals(tags, itemTags)
  const signals = unique(buildEvidence.signals.concat(itemSignals))
  const families = addonFamilies(addon)
  const relevance = familyRelevance(families, context)
  const rarityBonus = Math.max(0, effectiveRarity(addon && addon.rarity) - 1) * 1.5
  const selected = (selectedAddons || []).filter(Boolean)
  const selectedFamilies = unique(selected.reduce((all, entry) => all.concat(addonFamilies(entry)), []))
  const duplicated = families.filter(family => selectedFamilies.indexOf(family) !== -1)
  const complement = familyComplementScore(families, selectedFamilies)
  const pairPlan = selected.length === 1 ? getAddonPairPlan(addon, selected[0], context) : null
  const planScore = pairPlan ? pairPlan.score : 0
  const duplicatePenalty = duplicated.length * (pairPlan ? 3 : 9)
  const coverageValue = buildEvidence.coverage * 3
  const itemFitValue = itemSignals.length * 5
  const score = 24 + buildEvidence.score + coverageValue + itemFitValue + relevance + rarityBonus + complement.score + planScore - duplicatePenalty
  const breakdown = [
    factor('pairPlan', planScore, pairPlan && pairPlan.id),
    factor('wholeBuildFit', buildEvidence.score, buildEvidence.signals.join(', ')),
    factor('buildCoverage', coverageValue, `${buildEvidence.coverage}/${buildEvidence.coverageTotal}`),
    factor('directMatch', itemFitValue, itemSignals.join(', ')),
    factor('mechanicalFit', relevance, families.join(', ')),
    factor('pairComplement', complement.score, complement.matches.join(', ')),
    factor('rarityQuality', rarityBonus),
    factor('duplicateEffect', -duplicatePenalty, duplicated.join(', '))
  ]
  const reasons = []
  if (pairPlan) reasons.push(`S-tier plan: ${pairPlan.id}`)
  if (buildEvidence.coverage) reasons.push(`Build coverage ${buildEvidence.coverage}/${buildEvidence.coverageTotal}`)
  if (itemSignals.length) reasons.push(`Item mechanics: ${itemSignals.join(', ')}`)
  if (complement.score) reasons.push(`Complementary mechanics: ${complement.matches.join(', ')}`)
  if (duplicated.length) reasons.push(`Repeated effects: ${duplicated.join(', ')}`)
  if (!reasons.length) reasons.push('Compatible but situational add-on')
  return correlationResult(score, signals, reasons, breakdown, {
    families,
    complements: complement.matches,
    pairPlan: pairPlan && pairPlan.id,
    coverage: pairPlan ? pairPlan.coverage : buildEvidence.coverage,
    coverageTotal: buildEvidence.coverageTotal,
    perkFits: buildEvidence.perkFits
  })
}

export function scoreAddonPair (first, second, context) {
  if (!first || !second || first.id === second.id) return correlationResult(1, [], ['Invalid add-on pair'], [factor('incompatible', -99)])
  const firstScore = scoreAddonCorrelation(first, context, [])
  const secondScore = scoreAddonCorrelation(second, context, [])
  const firstFamilies = addonFamilies(first)
  const secondFamilies = addonFamilies(second)
  const duplicated = firstFamilies.filter(family => secondFamilies.indexOf(family) !== -1)
  const complement = familyComplementScore(firstFamilies, secondFamilies)
  const pairPlan = getAddonPairPlan(first, second, context)
  const planScore = pairPlan ? pairPlan.score : 0
  const duplicatePenalty = duplicated.length * (pairPlan ? 3 : 8)
  const score = (firstScore.score + secondScore.score) / 2 + complement.score + planScore - duplicatePenalty
  return correlationResult(
    score,
    firstScore.signals.concat(secondScore.signals),
    (pairPlan ? [`S-tier plan: ${pairPlan.id}`] : []).concat(firstScore.reasons, secondScore.reasons),
    [
      factor('pairPlan', planScore, pairPlan && pairPlan.id),
      factor('pairComplement', complement.score, complement.matches.join(', ')),
      factor('duplicateEffect', -duplicatePenalty, duplicated.join(', '))
    ],
    {
      addons: [first, second],
      complements: complement.matches,
      duplicatedFamilies: duplicated,
      pairPlan: pairPlan && pairPlan.id,
      pairPlanItemMatch: pairPlan ? pairPlan.itemMatch : null,
      coverage: pairPlan ? pairPlan.coverage : Math.max(firstScore.coverage || 0, secondScore.coverage || 0),
      coverageTotal: pairPlan ? pairPlan.coverageTotal : Math.max(firstScore.coverageTotal || 0, secondScore.coverageTotal || 0)
    }
  )
}

function perkKeywordCoverage (context, keywords) {
  return (context.perks || []).filter(perk => {
    const tags = ((perk && perk.tags) || []).map(normalizeTag)
    return keywords.some(keyword => tags.some(tag => tag.indexOf(keyword) !== -1))
  }).length
}

function perkSignalCoverage (context, signals) {
  return (context.perkSignalSets || []).filter(perkSignals => signals.some(signal => perkSignals.indexOf(signal) !== -1)).length
}

function offeringBuildPlanFit (offering, context) {
  const profile = offeringGameplayProfile(offering)
  const matchingPlans = (profile && profile.plans) || []
  const primaryPlan = context.plan && context.plan.primary
  const secondaryPlan = context.plan && context.plan.secondary
  const primaryMatch = primaryPlan && matchingPlans.indexOf(primaryPlan) !== -1
  const secondaryMatch = secondaryPlan && matchingPlans.indexOf(secondaryPlan) !== -1
  if (!primaryMatch && !secondaryMatch) return { score: 0, coverage: 0 }
  return {
    score: (primaryMatch ? 14 : 7) + Math.min(4, (profile && profile.rank) || 1),
    coverage: Math.max(1, primaryMatch ? context.plan.coverage || 0 : Math.min(2, context.plan.coverage || 0))
  }
}

export function scoreOfferingCorrelation (offering, context) {
  if (!entryAvailable(offering)) return correlationResult(1, [], ['Unavailable offering'], [factor('unavailable', -99)])
  if (!isGameplayOffering(offering)) return correlationResult(1, [], ['Excluded from the gameplay pool'], [factor('excludedPool', -99)])
  const tags = (offering && offering.tags) || []
  const normalizedTags = tags.map(normalizeTag)
  const hasExact = keywords => keywords.some(keyword => normalizedTags.indexOf(keyword) !== -1)
  const signals = sharedSignals(tags, context.buildTags || context.targetTags)
  const breakdown = []
  const gameplayProfile = offeringGameplayProfile(offering)
  let score = 32
  let coverage = 0

  const isSacrificialWard = offering.id === 'sacrificial_ward'
  const isMori = hasExact(['mori'])
  const isPersonalLuck = hasExact(['personalluck'])
  const isModifier = hasExact(['mapmodifier'])
  const isShroud = hasExact(['shroud'])

  if (isSacrificialWard) {
    score += 4
    breakdown.push(factor('mapModifierFit', 4))
  }

  if (isMori) {
    coverage = perkSignalCoverage(context, ['hook'])
    const value = 20 + ((gameplayProfile && gameplayProfile.rank) || 1) * 8 + coverage * 5
    score += value
    breakdown.push(factor('moriPressure', value))
  }

  if (isPersonalLuck) {
    coverage = perkKeywordCoverage(context, ['escapeattempt', 'selfunhook', 'chance'])
    const rank = (gameplayProfile && gameplayProfile.rank) || 1
    const value = coverage ? 8 + rank * 5 + coverage * 6 : -12
    score += value
    breakdown.push(factor('luckPlan', value))
  }

  if (isModifier) {
    const family = (gameplayProfile && gameplayProfile.family) || ''
    const rank = (gameplayProfile && gameplayProfile.rank) || 1
    let value = 2 + rank * 3
    if (family === 'survivor_chests' || family === 'killer_chests') {
      coverage = perkKeywordCoverage(context, ['chest', 'loot', 'rummage'])
    } else if (family === 'fog_dense') {
      coverage = perkSignalCoverage(context, ['stealth'])
    } else if (family === 'fog_clear') {
      coverage = perkSignalCoverage(context, ['information'])
      if ((context.buildSignals || []).indexOf('stealth') !== -1) value -= 14
    } else if (family.indexOf('hook_spacing') !== -1) {
      coverage = perkSignalCoverage(context, ['hook', 'sabotage'])
    } else if (family.indexOf('hatch_') === 0) {
      coverage = perkKeywordCoverage(context, ['hatch', 'endgame'])
    } else if (family.indexOf('basement_') === 0) {
      coverage = perkKeywordCoverage(context, ['basement', 'hook'])
    } else {
      if (hasExact(['chest'])) coverage = perkKeywordCoverage(context, ['chest', 'loot', 'rummage'])
      if (hasExact(['hatch'])) coverage = perkKeywordCoverage(context, ['hatch', 'endgame'])
      if (hasExact(['hook'])) coverage = perkSignalCoverage(context, ['hook', 'sabotage'])
      if (hasExact(['basement'])) coverage = perkKeywordCoverage(context, ['basement', 'hook'])
      if (hasExact(['fog'])) coverage = perkSignalCoverage(context, ['stealth'])
    }
    value += coverage * 6
    score += value
    breakdown.push(factor('mapModifierFit', value))
  }

  if (isShroud) {
    let value = 2
    if (offering.id === 'shroud_of_union') coverage = perkKeywordCoverage(context, ['teamplay', 'generator', 'coop'])
    if (offering.id === 'vigo_s_shroud') coverage = perkSignalCoverage(context, ['stealth'])
    if (offering.id === 'shroud_of_vanishing') coverage = perkSignalCoverage(context, ['stealth', 'generator'])
    value += coverage * 5
    score += value
    breakdown.push(factor('spawnPlan', value))
  }

  const buildPlanFit = offeringBuildPlanFit(offering, context)
  if (buildPlanFit.score) {
    score += buildPlanFit.score
    coverage = Math.max(coverage, buildPlanFit.coverage)
    breakdown.push(factor('buildPlanFit', buildPlanFit.score, context.plan.primary))
  }

  if (!breakdown.length) {
    score += 3
    breakdown.push(factor('neutralUtility', 3))
  }
  if (coverage) breakdown.unshift(factor('buildCoverage', coverage * 3, `${coverage}/${(context.perks || []).length}`))
  const reasons = breakdown.map(entry => `${entry.id} ${entry.value > 0 ? '+' : ''}${entry.value}`)
  return correlationResult(score, signals, reasons, breakdown, {
    offeringClass: isMori ? 'mori' : isPersonalLuck ? 'luck' : (isModifier || isSacrificialWard) ? 'modifier' : isShroud ? 'shroud' : 'utility',
    offeringFamily: gameplayProfile && gameplayProfile.family,
    offeringRank: gameplayProfile && gameplayProfile.rank,
    coverage,
    coverageTotal: (context.perks || []).length
  })
}
export function decorateCorrelation (entry, correlation) {
  return entry ? Object.assign({}, entry, { correlation }) : null
}
